// src/stores/authStore.ts - SIMPLIFIED FIXED VERSION
// (Removes the optimization that was causing the error)

import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import type { UserProfile } from '../types';

interface AuthStore {
  user: UserProfile | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  
  // Actions
  login: (user: UserProfile) => void;
  logout: () => Promise<void>;
  updateProfile: (updates: Partial<UserProfile>) => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthStore>()((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  // Simplified login - just set the user (no optimization)
  login: (user) => {
    set({ user, isAuthenticated: true, isLoading: false });
  },
  
  logout: async () => {
    try {
      // 1. Clear Zustand state immediately (optimistic update)
      set({ user: null, isAuthenticated: false });
      
      // 2. Sign out from Supabase (clears session + cookies)
      // const { error } = await supabase.auth.signOut();
      
      // if (error) {
      //   console.error('Supabase signOut error:', error);
      //   // Still proceed with logout even if Supabase fails
      // }
      
      // 3. Clear all localStorage (nuclear option - ensures no stale data)
      localStorage.clear();
      
    } catch (error) {
      console.error('Logout error:', error);
      // Force logout anyway
      set({ user: null, isAuthenticated: false });
      localStorage.clear();
    }
  },
  
  updateProfile: (updates) => 
    set((state) => ({
      user: state.user ? { ...state.user, ...updates } : null
    })),

  setLoading: (isLoading) => set({ isLoading }),
}));